// extracted by mini-css-extract-plugin
export default {"wrapper":"MovieList_wrapper__+YmXT"};